import { bindActionCreators } from 'redux';
import { getAllCustomFieldObjects } from '../../../common/actions/CommonAction';
import { O2OCommonContainer } from '../../../common/container/O2OContainer';
import { IState } from '../../../redux/reducer';
import ExportsHistoryComponentV2 from './ExportsHistoryComponentV2';

function mapStateToProps(rootState: IState) {
  return {
    allMoM: rootState.customFieldObjects,
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    getAllCustomFieldObjects: bindActionCreators(getAllCustomFieldObjects, dispatch),
  };
}

export const ExportsHistoryContainer = O2OCommonContainer(
  ExportsHistoryComponentV2,
  mapStateToProps,
  mapDispatchToProps
);
